module.exports = __webpack_public_path__ + "static/media/walletImg.252a3121.svg";